export default {
    type: 'widget',
    config: {
        defaultWidth: 80,
        icon: 'user',
        demotable: true
    },
    default: {},
    unique: [],
    sort: 'count',
    lang: {
        name: 'Player Count',
        views: ['list', 'grid'],
        category: 'Game',
        description: 'Summary of game counts including official and community voted, with colour coding and tooltips.'
    },
    filters: ['official.count', 'bgg.count']
}